import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { YMaps, Map, Placemark } from "@pbe/react-yandex-maps";
import { mapApiKey } from "../../config";

export default function MapSection({
  coordinates = [55.751574, 37.573856],
  hotel_name = "Наш отель",
  map_points = [],
  accentColor = "#14b8a6",
}) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return (
      <section id="map" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-12"
          >
            <span
              className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 text-sm font-medium rounded-full mb-4"
              style={{
                backgroundColor: `${accentColor}20`,
                color: accentColor,
              }}
            >
              Местоположение
            </span>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
              Как нас найти
            </h2>
          </motion.div>
          <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
            <div className="w-full h-[500px] bg-gray-100 flex items-center justify-center">
              <p className="text-gray-400">Загрузка карты...</p>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="map" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span
            className="inline-block px-4 py-1.5 bg-teal-100 text-teal-700 text-sm font-medium rounded-full mb-4"
            style={{ backgroundColor: `${accentColor}20`, color: accentColor }}
          >
            Местоположение
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            Как нас найти
          </h2>
        </motion.div>
        <div className="bg-white rounded-2xl overflow-hidden shadow-xl">
          <YMaps query={{ apikey: mapApiKey }}>
            <Map
              defaultState={{
                center: coordinates,
                zoom: 15,
              }}
              width="100%"
              height="500px"
            >
              {/* Основная метка отеля */}
              <Placemark
                geometry={coordinates}
                properties={{
                  iconContent: hotel_name,
                }}
                options={{
                  preset: "islands#blueStretchyIcon",
                  draggable: false,
                }}
              />

              {/* Дополнительные точки на карте */}
              {map_points?.length > 0 &&
                map_points.map((obj) => (
                  <Placemark
                    key={`obj_${obj.id}`}
                    geometry={[obj.coords?.[0], obj.coords?.[1]]}
                    properties={{
                      iconContent: obj.name,
                    }}
                    options={{
                      preset: "islands#blueStretchyIcon",
                      draggable: false,
                    }}
                  />
                ))}
            </Map>
          </YMaps>
        </div>
      </div>
    </section>
  );
}
